import React from 'react';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function EventCloneModal(props) {
    const close = () => {
        props.closeHandler();
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title="Clone project" close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            <div className="tw-grid tw-grid-cols-1">
                                <label className="modal__msg modal__text-color">
                                    Project cloning has started successfully. This process may take several minutes.
                                </label>
                            </div>
                            <div className="modal__footer">
                                <Button variant="secondary" onClick={close}>
                                    {$t('Close')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
